import { create } from 'zustand';
import { UserSchema } from '@/entities/user/model';

export interface UserStore {
  user: UserSchema | null;
  setUser: (user: UserSchema | null) => void;
  resetUser: () => void;
  getUserId: () => string;
}

export const useUserStore = create<UserStore>((set, get) => ({
  user: null,
  setUser: (user) => set({ user }),
  resetUser: () => set({ user: null }),
  getUserId: () => get().user?.id ?? ''
}));
